import React, { useState } from 'react'
import {
  Button,
  GridItem,
  ItemsGrid,
  Flex,
  MainHeadline,
  PageWrapper,
  PageFooter,
} from '../../../styling/GlobalStyles'
import { Pagination } from '../../../components/Pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import { NavBar } from '../../../components/NavBar/NavBar'
import { clearClientRolesList, deleteClientRole, getClientRoles } from 'features/roles/clientRolesSlice'
import { useDispatch, useSelector } from 'react-redux'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { setConfirmModal } from 'features/global/globalSlice'
import { AppDispatch, RootState } from 'store'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { getParams, handlePagination } from 'utils/helpers'
import { ITableItem, ModalTypes } from 'types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'

export const ClientRoles = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { roles = [], totalPages } = useSelector((store: RootState) => store.clientRoles)
  const [params, setParams] = useState<any>(getParams({ location }))

  useQueryPagination({ fetchFunctions: [getClientRoles], cleanUpFunctions: [clearClientRolesList], params })

  const removeRole = (id: string | number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteClientRole(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: roles.length < 2,
        },
        word: 'delete role',
      }),
    )
  }

  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Roles...' setParams={setParams} />
      <PageWrapper>
        <Flex between center mb='16' >
          <MainHeadline>Roles</MainHeadline>
          <Flex gap='1rem' >
            <Button orange onClick={() => navigate('permission-policies')}>
              Permission Policies
            </Button>
            <Button orange onClick={() => navigate('add')}>
              Add role
            </Button>
          </Flex>
        </Flex>
        <ItemsGrid columns={3} mt='25px'>
          {roles.length ? (
            roles.map(({ name, id }: ITableItem) => {
              return (
                <GridItem key={id}>
                  <p onClick={() => navigate('/hr/roles/role/' + id)} >
                    {name}
                  </p>

                  <Flex between center onClick={() => removeRole(id)}>
                    <RemoveCircle />
                  </Flex>
                </GridItem>
              )
            })
          ) : (
            <NoItems title='Roles' />
          )}
        </ItemsGrid>
      </PageWrapper>

      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
